export default __webpack_public_path__ + "static/media/notAllowed.b0090731.jpeg";